import { useCallback, useEffect, useRef, useState } from 'react';
import { router } from '@inertiajs/react';

// /todo 那两个搜索框背后的行为。抽出来是因为它有两个调用方（三栏页与回收站
// 页，两者都渲染同一个 Sidebar），而里面有两条**试出来的**结论：300ms 的停手
// 时长，以及下面那个 replace 的判断。散成两份，第一次改就会漂。
//
// 输入的值只在这里存一份 —— 左栏一个框、中栏一个框显示的是同一个词，
// 它们不是两次搜索，是同一次搜索的两个镜子。
const DEBOUNCE = 300;

type Options = {
  // 服务端当前是不是已经在搜（Todo 页的 todo.q）。回收站页永远是 undefined。
  activeQuery: string | undefined;
  // 清掉搜索词回哪。Todo 页给的是「开始搜之前那一栏」的地址。
  originHref: string;
};

export default function useTaskSearch({ activeQuery, originHref }: Options) {
  // 初始化一次就不再回写。做「props 变了就同步 draft」会让一次慢响应把你
  // 正在敲的后半截冲掉 —— Wiki/SearchBar 也是这个取舍。
  const [draft, setDraft] = useState(activeQuery ?? '');
  const mounted = useRef(false);

  const clear = useCallback(() => {
    setDraft('');
    router.visit(originHref);
  }, [originHref]);

  useEffect(() => {
    // 首次渲染不发请求：那会把一次普通的进页面变成一次带参数的导航。
    if (!mounted.current) {
      mounted.current = true;
      return undefined;
    }

    const q = draft.trim();
    const timer = setTimeout(() => {
      if (q) {
        // 不做「按回车才搜」：这一页的搜索是**扫**，边打边看结果是它的用法。
        //
        // replace 只在**已经**在筛选时为真：
        // - 没筛 → 筛：推一条历史，于是后退键能回到没筛选的那一列表
        // - 筛选中继续敲字：替换，否则每敲一个字推一条，按一次后退只退一个字母
        //
        // preserveState 不能省：否则输入框会在每次响应回来时被重建，
        // 光标跳到末尾。
        router.get(
          '/todo/backlog',
          { q },
          { preserveState: true, preserveScroll: true, replace: Boolean(activeQuery) }
        );
      } else if (activeQuery) {
        clear();
      }
    }, DEBOUNCE);

    return () => clearTimeout(timer);
  }, [draft, activeQuery, clear]);

  return { draft, setDraft, clear };
}
